var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"label":_vm.label,"enum":_vm.turler,"disabled":_vm.disabled,"labels":_vm.hesapSekliLabel,"rules":_vm.rules,"default-first":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }